import "./bootstrap";
import * as Sentry from "@sentry/browser";
import htmx from "htmx.org";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import persist from "@alpinejs/persist";
import initGroupSearch from "./modules/group-search";
import initUnsavedFormHandler from "./modules/unsaved-form-handler";
import initCookieConsent from "./modules/cookie-consent";
import initFilePond from "./modules/filepond/filepond.js";
import initQRCodeGenerator from "./modules/qrcode-generator.js";
import initTimezoneHandler from "./modules/timezone-handler.js";

const ignoredSentryErrors = [
    "Object Not Found Matching Id:",
    "Error invoking postMessage: Java object is gone",
    "Error invoking enableDidUserTypeOnKeyboardLogging: Java object is gone",
    "Failed to fetch dynamically imported module:",
    "Importing a module script failed.",
];

window.Sentry = Sentry.init({
    dsn: "https://06bed7dbd2e02f68640a50237c6d28fc@sentry.tipp.ly/3",
    sendDefaultPii: true,
    debug: !import.meta.env.VITE_SENTRY_RELEASE,
    release: import.meta.env.VITE_SENTRY_RELEASE || "dev",
    beforeSend(event) {
        const message = event.message || event.exception?.values?.[0]?.value || "";

        if (ignoredSentryErrors.some((ignoredError) => message.includes(ignoredError))) {
            return null;
        }

        return event;
    },
    integrations: [Sentry.browserTracingIntegration(), Sentry.extraErrorDataIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    tracesSampleRate: 0,
    tracePropagationTargets: ["localhost", "http://tipply.test", "https://tipp.ly"],
});

window.Alpine = Alpine;
window.htmx = htmx;

Alpine.plugin(focus);
Alpine.plugin(persist);

initGroupSearch();
initUnsavedFormHandler();
initCookieConsent();
initFilePond();
initQRCodeGenerator();
initTimezoneHandler();

Alpine.start();

// Lazy load session replay
import("@sentry/browser").then((lazyLoadedSentry) => {
    Sentry.addIntegration(
        lazyLoadedSentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
    );
});
